import React from 'react'
import Skeleton from 'react-loading-skeleton'
import {
  ContentContainer,
  TableContainer
} from '../ReleaseList/ReleaseList.styles'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import { useDesktopMediaQuery } from 'utils/hooks/useMediaQueries'

const SKELTON_LIST_ITEM_COUNT = 10

const ListItemSkeleton = () => {
  const responsiveBreakpointsVersion = useResponsiveBreakpointsVersion()
  const responsiveBreakpointsV2 =
    responsiveBreakpointsVersion === RESPONSIVE_BREAKPOINT_VERSIONS.V2
  const isDesktop = useDesktopMediaQuery()

  return (
    <ContentContainer $responsiveBreakpointsV2={responsiveBreakpointsV2}>
      <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
        <Skeleton height={60} width={60} />
        <div style={{ marginLeft: 20, flex: 1 }}>
          <Skeleton height={20} width={`85%`} />
        </div>
      </div>
      <Skeleton height={20} width={`85%`} />
      <Skeleton height={20} width={`70%`} />
      <Skeleton height={20} width={`70%`} />
      {isDesktop && (
        <>
          <Skeleton height={20} width={`65%`} />
          <Skeleton height={20} width={`70%`} />
          <Skeleton height={20} width={`85%`} />
          <Skeleton height={20} width={`90%`} />
        </>
      )}
    </ContentContainer>
  )
}

export default function ReleaseListSkeleton() {
  return (
    <TableContainer>
      <tbody>
        {Array(SKELTON_LIST_ITEM_COUNT)
          .fill()
          .map((_, index) => (
            <ListItemSkeleton key={index} />
          ))}
      </tbody>
    </TableContainer>
  )
}
